



























































export default {
	name: 'SidebarItem',

	props: {
		text: {
			required: true,
			type: String,
		},
		icon: {
			required: false,
			type: String,
		},
		link: {
			default: '/',
			required: false,
			type: String,
		},
		path: {
			default: null,
			required: false,
			type: String,
		},
		active: {
			default: false,
			required: false,
			type: Boolean,
		},
		collapsed: {
			default: false,
			required: false,
			type: Boolean,
		},

		isNotification: {
			default: false,
			required: false,
			type: Boolean,
		},
		unread: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	computed: {
		route() {
			return this.path || this.localePath({ name: this.link });
		},
	},
};
